import { requestGet, requestPost } from '@/common/request';

export default {
  // 招商底池 - 折线图数据
  async merchantPooldataChart(query) {
    return await requestGet('/merchantPool/dataChart', query);
  },

  // 招商底池 - 报名人列表
  async merchantPoollistApplicants(query) {
    return await requestGet('/merchantPool/listApplicants', query);
  },
  // 招商底池 -  商品列表
  async merchantPoollistGoods(query) {
    return await requestGet('/merchantPool/listGoods', query);
  },

  // 招商底池 -  报名人\商品导出剩余次数
  async merchantPoolexportRemain(query) {
    return await requestGet('/merchantPool/exportRemain', query);
  },

  // 招商底池 -  报名人\商品导出列表
  async merchantPoollistExport(query) {
    return await requestGet('/merchantPool/listExport', query);
  },

  // 招商底池 -  报名人\商品导出
  async merchantPoolExport(query) {
    return await requestGet('/merchantPool/export', query);
  },
  // 招商底池 -  header信息
  async merchantPoolheader(query) {
    return await requestGet('/merchantPool/header', query);
  },
  // 查询标签申请信息
  async merchantPoolapplyTagInfo(query) {
    return await requestGet('/merchantPool/applyTagInfo', query);
  },
  // 保存标签信息
  async merchantPoolapplyTag(planCode, query) {
    return await requestPost('/merchantPool/applyTag?planCode=' + planCode, query);
  },
  // 查询标签审批流信息
  async merchantPoolapplyTagProcessInfo(query) {
    return await requestGet('/merchantPool/applyTagProcessInfo', query);
  },
  // oss文件上传接口 //module=招商底池
  async fileUpload(query) {
    return await requestPost('/oss/file/upload?module=4', query);
  },
  // 批量退出活动文件上传接口
  async fileUploadBatchQuit(query) {
    return await requestPost('/oss/file/upload?module=9', query);
  },
  // 批量添加商品
  async merchantPoolUpload(query) {
    return await requestGet('/merchantPool/upload', query);
  },
  // 招商底池 -  执行打标
  async merchantPooldoTag(query) {
    return await requestGet('/merchantPool/doTag', query);
  },
  async uploadPic(width, height, maxWidth, query) {
    return await requestPost('/file/uploadFile?width=' + width + '&height=' + height + '&maxWidth=' + maxWidth, query);
  },
  // 招商底池 - 规则文案列表
  async merchantPoollistUploadRuleWord(query) {
    return await requestGet('/merchantPool/listUploadRuleWord', query);
  },
  //招商底池 - 规则校验补录列表
  async merchantPoollistUploadRule(query) {
    return await requestGet('/merchantPool/listUploadRule', query);
  },
  // 招商底池 - 规则校验补录
  async merchantPooluploadRule(query) {
    return await requestGet('/merchantPool/uploadRule', query);
  },
  async merchantPoolListUploadRule(query) {
    return await requestGet('/merchantPool/listUploadRule', query);
  },
  // 招商底池-催报接口
  async yxApplyApiServiceYxUrgedApply(query) {
    return await requestPost('/generic/themeActivity/yxApplyApiService/yxUrgedApply', query);
  },
  // 招商底池-催报状态
  async yxApplyApiServiceUrgedApplyStatus(query) {
    return await requestPost('/generic/themeActivity/yxApplyApiService/urgedApplyStatus', query);
  },
  //招商底池-查询价格校验天数
  async queryPriceDefaultQuaConfig(query) {
    return await requestGet('/activity/priceQuaTime/queryPriceDefaultQuaConfig', query);
  },
};
